import { DeleteOutlineIcon } from '@carboncopyco/icons';
import { ConfirmAlert } from '@carboncopyco/ui';

export interface ExitEditorDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const ExitEditorDialog = ({
  onConfirm,
  onClose,
  isOpen,
}: ExitEditorDialogProps) => (
  <ConfirmAlert
    containerClass="w-ds-500"
    show={isOpen}
    onConfirm={onConfirm}
    noLabel="Cancel"
    danger
    description="Discard your changes and leave the editor?"
    onClose={onClose}
    title="Discard changes"
    yesIcon={<DeleteOutlineIcon />}
    yesLabel="Discard and exit"
  />
);
